export const COMMENT_MENU_DELETE = 'comment-menu.delete';
export const COMMENT_MENU_DELETION_DIALOG_MESSAGE = 'comment-menu.deletion-dialog-message';
